import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeBoundaryTemplates from "./routes/GradeBoundaryTemplates";
export default store => ({
  path: "grade-boundaries",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [GradeBoundaryTemplates(store)],
});
